import { NgModule, Type } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { BasicInsuranceModule } from '../pages/basic-insurance/basic-insurance.module';
import { KeyDataModule } from '../pages/key-data/key-data.module';
import { SummaryModule } from '../pages/summary/summary.module';
import { SubmissionModule } from '../pages/submission/submission.module';
import { SupplementaryInsuranceModule } from '../pages/supplementary-insurance/supplementary-insurance.module';
import { personsRegisteredGuard } from './guards/persons-registered/persons-registered.guard';
import { OrderOfferModule } from '../pages/order-offer/order-offer.module';
import { personExistsGuard } from './guards/person-exists/person-exists.guard';
import { campaignGuard } from './guards/campaign/campaign.guard';
import { CampaignModule } from '../pages/campaign/campaign.module';
import { frameworkContractsGuard } from './guards/framework-contracts/framework-contracts.guard';
import { FrameworkContractErrorModule } from '../pages/framework-contract-error/framework-contract-error.module';
import { langFromQueryParamGuard } from './guards/langFromQueryParam/lang-from-query-param.guard';
import { tupGuard } from './guards/tup/tup.guard';

export type RoutePath =
  | ''
  | 'basic-insurance/:personId'
  | 'supplementary-insurance/:personId'
  | 'summary'
  | 'submission'
  | 'order-offer'
  | 'tup'
  | 'insurance/:product'
  | 'framework-contracts-error'
  | '**';

export interface SscRoute extends Route {
  path: RoutePath;
}

const routes: SscRoute[] = [
  {
    path: '',
    loadChildren: (): Promise<Type<KeyDataModule>> =>
      import('../pages/key-data/key-data.module').then((m) => m.KeyDataModule),
    canActivate: [frameworkContractsGuard, langFromQueryParamGuard],
  },
  {
    path: 'tup',
    loadChildren: (): Promise<Type<KeyDataModule>> =>
      import('../pages/key-data/key-data.module').then((m) => m.KeyDataModule),
    canActivate: [tupGuard, langFromQueryParamGuard],
  },
  {
    path: 'basic-insurance/:personId',
    loadChildren: (): Promise<Type<BasicInsuranceModule>> =>
      import('../pages/basic-insurance/basic-insurance.module').then((m) => m.BasicInsuranceModule),
    canActivate: [personsRegisteredGuard, personExistsGuard],
  },
  {
    path: 'supplementary-insurance/:personId',
    loadChildren: (): Promise<Type<SupplementaryInsuranceModule>> =>
      import('../pages/supplementary-insurance/supplementary-insurance.module').then(
        (m) => m.SupplementaryInsuranceModule,
      ),
    canActivate: [personsRegisteredGuard, personExistsGuard],
  },
  {
    path: 'summary',
    loadChildren: (): Promise<Type<SummaryModule>> =>
      import('../pages/summary/summary.module').then((m) => m.SummaryModule),
    canActivate: [personsRegisteredGuard],
  },
  {
    path: 'submission',
    loadChildren: (): Promise<Type<SubmissionModule>> =>
      import('../pages/submission/submission.module').then((m) => m.SubmissionModule),
    canActivate: [personsRegisteredGuard],
  },
  {
    path: 'order-offer',
    loadChildren: (): Promise<Type<OrderOfferModule>> =>
      import('../pages/order-offer/order-offer.module').then((m) => m.OrderOfferModule),
    canActivate: [personsRegisteredGuard],
  },
  {
    path: 'insurance/:product',
    loadChildren: (): Promise<Type<CampaignModule>> =>
      import('../pages/campaign/campaign.module').then((m) => m.CampaignModule),
    canActivate: [campaignGuard, langFromQueryParamGuard],
  },
  {
    path: 'framework-contracts-error',
    loadChildren: (): Promise<Type<FrameworkContractErrorModule>> =>
      import('../pages/framework-contract-error/framework-contract-error.module').then(
        (m) => m.FrameworkContractErrorModule,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
